export default {
  searchQuery: null,
  fetching: false,
  searchResults: []
};



// WEBPACK FOOTER //
// ./public/components/MasterSearchBar/initialState.js